/** User-facing GAD-7 pattern signal (inferred from reflections, not administered screening). */
export const GAD7_TITLE = "GAD-7 signal";
export const GAD7_SUBTITLE =
  "Pattern intensity from confirmed emotions and thinking patterns in your reflections (past 14 days)";

export const GAD7_ROUTE = "/behavioral-patterns/gad-7";

export const GAD7_MAX_SCORE = 21;

export const GAD7_WINDOW_DAYS = 14;

export const GAD7_ELEVATED_THRESHOLD = 10;

export const GAD7_FREQUENCY_LABELS = [
  "Not at all",
  "Several days",
  "More than half the days",
  "Nearly every day"
];

export const GAD7_ITEMS = [
  {
    id: "nervous_anxious",
    label: "On edge",
    symptom: "Feeling nervous, anxious, or on edge"
  },
  {
    id: "cant_stop_worrying",
    label: "Uncontrolled worry",
    symptom: "Not being able to stop or control worrying"
  },
  {
    id: "worry_many_things",
    label: "Many worries",
    symptom: "Worrying too much about different things"
  },
  {
    id: "trouble_relaxing",
    label: "Trouble relaxing",
    symptom: "Trouble relaxing"
  },
  {
    id: "restless",
    label: "Restlessness",
    symptom: "Being so restless that it is hard to sit still"
  },
  {
    id: "irritable",
    label: "Irritability",
    symptom: "Becoming easily annoyed or irritable"
  },
  {
    id: "afraid_awful",
    label: "Catastrophic fear",
    symptom: "Feeling afraid as if something awful might happen"
  }
];

export const GAD7_DISCLAIMER =
  "This GAD-7 signal is derived from your reflection history—preferring confirmed Quick Clarity emotions and thinking patterns, plus text signals. It is not an administered clinical screening and does not diagnose any condition.";

export function getGad7FrequencyLabel(score) {
  if (score == null || score < 0) return GAD7_FREQUENCY_LABELS[0];
  const idx = Math.min(3, Math.max(0, Math.round(score)));
  return GAD7_FREQUENCY_LABELS[idx];
}

export function getGad7SeverityLabel(totalScore) {
  if (totalScore == null) return null;
  if (totalScore <= 4) return "Minimal anxiety signal";
  if (totalScore <= 9) return "Mild anxiety signal";
  if (totalScore <= 14) return "Moderate anxiety signal";
  return "Severe anxiety signal";
}

/** Procedural note when signal is elevated — not a diagnosis. */
export function getGad7SeverityNote(totalScore) {
  if (totalScore == null || totalScore < GAD7_ELEVATED_THRESHOLD) return null;
  return "Elevated pattern load. Consider a structured evaluation with a licensed provider if this persists.";
}
